// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@assets/inventory/equip_panel_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@assets/inventory/charinfo_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@assets/inventory/box_btn_idle.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("@assets/inventory/box_btn_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("@assets/lv_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("@assets/inventory/sp_bg_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("@assets/inventory/add_stat_btn.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 32px;
}

.team-content-card-container {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Kim';
}

.team-equip-container {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 100% 100%;
    padding: 8px;
    gap: 6px;;
    margin-left: -4px;
}

.team-content-container {
    display: flex;
    flex-direction: column;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: 100% 100%;
    width: 382px;
    height: 400px;
    position: relative;
}

.equip-item {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: 100% 100%;
    padding: 8px;
    display: flex;
    align-items: center;
}

.sheet-item {
    box-sizing: border-box;
    width: 43px;
    height: 43px;
    background-color: #1c1f25;
    border-radius: 6px;
    border: 1px solid #274c57;
    padding: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.sheet-item:hover {
    cursor: pointer;
    border: 1px solid #71deff;
}

.sheet-item img {
    width: 100%;
    height: 100%;
}

.special-equip {
    width: 32px;
    height: 32px;
}

.equip-item:hover {
    cursor: pointer;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.equip-item img {
    width: 24px;
    height: 28px;
}

.team-level {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 18px;
    left: -30px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: 100% 100%;
    width: 64px;
    height: 64px;
    font-family: 'Kim';
}

.team-level span {
    font-size: 10px;
    color: #ffa600;
}

.team-level .level-span {
    font-size: 16px;
    color: #ffffff;
    font-weight: 600;
}

.team-info-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 92px;
    padding: 0 16px 0 52px;
}

.team-sp-container {
    cursor: pointer;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});  
    background-size: 100% 100%;
    width: 60px;
    height: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 2px;
}

.team-sp-container span {
    font-size: 12px;
    color: #ffffff;
}

.team-sp-container .sp-span {
    font-size: 16px;
    font-weight: 600;
    color: #71deff;
}

.team-character-name {
    max-width: 170px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    text-transform: capitalize;
    font-family: 'Kim';
}

.team-character-class {
    max-width: 114px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 10px;
    font-weight: 500;
    color: #ffa600;
    text-transform: uppercase;
}

.team-exp-info span {
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
}

.team-exp-info span .team-curr-exp {
    font-weight: 400;
    color: #71deff;
}

.team-exp-info span .team-total-exp {
    font-weight: 400;
}

.team-exp-slider-container {
    width: 214px;
    height: 6px;
    background-color: #1c1f25;
    border-radius: 2px;
    margin-top: 8px;
    position: relative;
}

.team-curr-exp-slider {
    background-color: #71deff;
    border-radius: 2px;
    height: 100%;
    width: 74%;
    position: absolute;
    top: 0;
    left: 0;
}

.team-character-info-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 24px;
    padding: 24px 0 8px 0;
}

.team-character-container {
    width: 64px;
    height: 102px;
    position: relative;
}

.team-character {
    width: 100%;
    height: 100%;
    background-position: -40px -40px;
    background-repeat: no-repeat;
    animation: animate-sprite 0.7s steps(1) infinite;
    transform: scale(.6);
}

.team-character-overlay {
    width: 48px; 
    height: 64px;
    position: absolute;
    top: 0;
    left: 0;
    background-repeat: no-repeat;
    display: block;
}

/* Additional animation keyframes for power-up */
@keyframes power-up-animation {
    from { background-position: 0px 0; }
    to { background-position: -816px 0; } 
  }  

.team-character-info {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    gap: 4px 6px;
}

.character-info-bar {
    width: 108px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
    background-color: #1c1f25;
    border-radius: 4px;
    padding: 4px;
    position: relative;
    cursor: pointer;
}

.character-info-bar .info-class {
    position: absolute;
    top: 0;
    left: 0;
    width: 46px;
    height: 100%;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Kim';
    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
}

.character-info-bar .info-class span {
    font-size: 12px;
    font-weight: 500;
    color: #ffffff;
}

.character-info-bar .curr-info-container {
    width: 60px;
    display: flex;
    justify-content: center;
    font-family: 'Kim';
    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
}

.character-info-bar .curr-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
    color: #ffffff;
}

.character-info-bar .info-bar-plus {
    position: absolute;
    right: 4px;
    top: 50%;
    transform: translateY(-50%);
    width: 12px;
    height: 12px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    background-size: 100% 100%;
    border: none;
    cursor: pointer;
}

.character-info-bar .info-bar-plus:hover {
    opacity: 0.8;
}

.team-items-container {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 12px;
}

.character-icon-container {
    padding-top: 16px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
    max-width: 96px;
}

.character-icon {
    box-sizing: border-box;
    width: 43px;
    height: 43px;
    background-color: #1c1f25;
    border-radius: 6px;
    border: 1px solid #274c57;
    padding: 8px 6px;
}

.character-icon:hover {
    cursor: pointer;
    border: 1px solid #71deff;
}

.character-icon img {
    width: 100%;
    height: 100%;
}

.team-item-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 92px;
}

.team-item-container .team-item-heading {
    width: 100%;
    border-bottom: 1px solid #ffa600;
}

.team-items {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    gap: 4px 6px; 
}

.team-items .team-item {
    box-sizing: border-box;
    width: 43px;
    height: 43px;
    background-color: #1c1f25;
    border-radius: 6px;
    border: 1px solid #274c57;
    padding: 4px;
}

.team-items .team-item img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}

.team-items .team-item:hover {
    cursor: pointer;
    border: 1px solid #71deff;
}

`, "",{"version":3,"sources":["webpack://./src/components/characterSheet/CharacterSheet.style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,yDAA6D;IAC7D,0BAA0B;IAC1B,YAAY;IACZ,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,yDAA0D;IAC1D,0BAA0B;IAC1B,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,yDAA2D;IAC3D,0BAA0B;IAC1B,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,yDAA6D;AACjE;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,yDAA0C;IAC1C,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,yDAA2D;IAC3D,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,4BAA4B;IAC5B,gDAAgD;IAChD,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,4BAA4B;IAC5B,cAAc;AAClB;;AAEA,gDAAgD;AAChD;IACI,OAAO,0BAA0B,EAAE;IACnC,KAAK,6BAA6B,EAAE;EACtC;;AAEF;IACI,aAAa;IACb,qCAAqC;IACrC,kCAAkC;IAClC,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;IACR,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iEAAiE;AACrE;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,iEAAiE;AACrE;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,yDAA2D;IAC3D,0BAA0B;IAC1B,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,kCAAkC;IAClC,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B","sourcesContent":[".team-content {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 32px;\n}\n\n.team-content-card-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-family: 'Kim';\n}\n\n.team-equip-container {\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background-image: url('@assets/inventory/equip_panel_bg.png');\n    background-size: 100% 100%;\n    padding: 8px;\n    gap: 6px;;\n    margin-left: -4px;\n}\n\n.team-content-container {\n    display: flex;\n    flex-direction: column;\n    background-image: url('@assets/inventory/charinfo_bg.png');\n    background-size: 100% 100%;\n    width: 382px;\n    height: 400px;\n    position: relative;\n}\n\n.equip-item {\n    background-image: url('@assets/inventory/box_btn_idle.png');\n    background-size: 100% 100%;\n    padding: 8px;\n    display: flex;\n    align-items: center;\n}\n\n.sheet-item {\n    box-sizing: border-box;\n    width: 43px;\n    height: 43px;\n    background-color: #1c1f25;\n    border-radius: 6px;\n    border: 1px solid #274c57;\n    padding: 4px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.sheet-item:hover {\n    cursor: pointer;\n    border: 1px solid #71deff;\n}\n\n.sheet-item img {\n    width: 100%;\n    height: 100%;\n}\n\n.special-equip {\n    width: 32px;\n    height: 32px;\n}\n\n.equip-item:hover {\n    cursor: pointer;\n    background-image: url('@assets/inventory/box_btn_active.png');\n}\n\n.equip-item img {\n    width: 24px;\n    height: 28px;\n}\n\n.team-level {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    top: 18px;\n    left: -30px;\n    background-image: url('@assets/lv_bg.png');\n    background-size: 100% 100%;\n    width: 64px;\n    height: 64px;\n    font-family: 'Kim';\n}\n\n.team-level span {\n    font-size: 10px;\n    color: #ffa600;\n}\n\n.team-level .level-span {\n    font-size: 16px;\n    color: #ffffff;\n    font-weight: 600;\n}\n\n.team-info-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 92px;\n    padding: 0 16px 0 52px;\n}\n\n.team-sp-container {\n    cursor: pointer;\n    background-image: url('@assets/inventory/sp_bg_active.png');  \n    background-size: 100% 100%;\n    width: 60px;\n    height: 60px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding-top: 2px;\n}\n\n.team-sp-container span {\n    font-size: 12px;\n    color: #ffffff;\n}\n\n.team-sp-container .sp-span {\n    font-size: 16px;\n    font-weight: 600;\n    color: #71deff;\n}\n\n.team-character-name {\n    max-width: 170px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 16px;\n    font-weight: 500;\n    color: #ffffff;\n    text-transform: capitalize;\n    font-family: 'Kim';\n}\n\n.team-character-class {\n    max-width: 114px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 10px;\n    font-weight: 500;\n    color: #ffa600;\n    text-transform: uppercase;\n}\n\n.team-exp-info span {\n    font-size: 14px;\n    font-weight: 600;\n    color: #ffffff;\n}\n\n.team-exp-info span .team-curr-exp {\n    font-weight: 400;\n    color: #71deff;\n}\n\n.team-exp-info span .team-total-exp {\n    font-weight: 400;\n}\n\n.team-exp-slider-container {\n    width: 214px;\n    height: 6px;\n    background-color: #1c1f25;\n    border-radius: 2px;\n    margin-top: 8px;\n    position: relative;\n}\n\n.team-curr-exp-slider {\n    background-color: #71deff;\n    border-radius: 2px;\n    height: 100%;\n    width: 74%;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.team-character-info-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 24px;\n    padding: 24px 0 8px 0;\n}\n\n.team-character-container {\n    width: 64px;\n    height: 102px;\n    position: relative;\n}\n\n.team-character {\n    width: 100%;\n    height: 100%;\n    background-position: -40px -40px;\n    background-repeat: no-repeat;\n    animation: animate-sprite 0.7s steps(1) infinite;\n    transform: scale(.6);\n}\n\n.team-character-overlay {\n    width: 48px; \n    height: 64px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-repeat: no-repeat;\n    display: block;\n}\n\n/* Additional animation keyframes for power-up */\n@keyframes power-up-animation {\n    from { background-position: 0px 0; }\n    to { background-position: -816px 0; } \n  }  \n\n.team-character-info {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: repeat(3, 1fr);\n    gap: 4px 6px;\n}\n\n.character-info-bar {\n    width: 108px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 4px;\n    background-color: #1c1f25;\n    border-radius: 4px;\n    padding: 4px;\n    position: relative;\n    cursor: pointer;\n}\n\n.character-info-bar .info-class {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 46px;\n    height: 100%;\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-family: 'Kim';\n    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n}\n\n.character-info-bar .info-class span {\n    font-size: 12px;\n    font-weight: 500;\n    color: #ffffff;\n}\n\n.character-info-bar .curr-info-container {\n    width: 60px;\n    display: flex;\n    justify-content: center;\n    font-family: 'Kim';\n    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n}\n\n.character-info-bar .curr-info {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 12px;\n    font-weight: 500;\n    color: #ffffff;\n}\n\n.character-info-bar .info-bar-plus {\n    position: absolute;\n    right: 4px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 12px;\n    height: 12px;\n    background-image: url('@assets/inventory/add_stat_btn.png');\n    background-size: 100% 100%;\n    border: none;\n    cursor: pointer;\n}\n\n.character-info-bar .info-bar-plus:hover {\n    opacity: 0.8;\n}\n\n.team-items-container {\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    gap: 12px;\n}\n\n.character-icon-container {\n    padding-top: 16px;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 8px;\n    max-width: 96px;\n}\n\n.character-icon {\n    box-sizing: border-box;\n    width: 43px;\n    height: 43px;\n    background-color: #1c1f25;\n    border-radius: 6px;\n    border: 1px solid #274c57;\n    padding: 8px 6px;\n}\n\n.character-icon:hover {\n    cursor: pointer;\n    border: 1px solid #71deff;\n}\n\n.character-icon img {\n    width: 100%;\n    height: 100%;\n}\n\n.team-item-container {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 92px;\n}\n\n.team-item-container .team-item-heading {\n    width: 100%;\n    border-bottom: 1px solid #ffa600;\n}\n\n.team-items {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: repeat(3, 1fr);\n    gap: 4px 6px; \n}\n\n.team-items .team-item {\n    box-sizing: border-box;\n    width: 43px;\n    height: 43px;\n    background-color: #1c1f25;\n    border-radius: 6px;\n    border: 1px solid #274c57;\n    padding: 4px;\n}\n\n.team-items .team-item img {\n    width: 100%;\n    height: 100%;\n    border-radius: 4px;\n}\n\n.team-items .team-item:hover {\n    cursor: pointer;\n    border: 1px solid #71deff;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
